import React, { useEffect, useState } from "react";
import Nav from "../../master/NavBar";
import Header from "../../master/SideBar";
import { LoadingDiv, SweetAlertShow } from "../../master/Master";
import { StaffList } from "../../../api/Staff";
import { courseList } from "../../../api/Courses";
import { useNavigate } from "react-router-dom";
import { batchAdd } from "../../../api/Batch";
import { feeTypes } from "../../config/Data";
import AcademicPortalLayout from "../AcademicPortalLayout";

export default function BatchAdd() {
  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [courses, setCourses] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setSessions(JSON.parse(localStorage.getItem("sessions") ?? "[]"));
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await batchAdd(formData);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
        navigate("/batches");
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getStaffs = async () => {
    setLoading(true);
    try {
      const response = await StaffList();
      if (response.data.status) {
        setStaffs(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const courseFetch = async () => {
    setLoading(true);
    try {
      const response = await courseList();
      if (response.data.status) {
        setCourses(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    courseFetch();
    getStaffs();
  }, []);

  const [feeStructure, setFeeStructure] = useState([
    {
      fee_type: "Registration Fee",
      amount: "",
      apply_on: "All student",
    },
  ]);

  const addFeeRow = () => {
    if (feeStructure.length >= feeTypes.length) {
      SweetAlertShow(
        "info",
        "Warning",
        "All fee types have already been added."
      );
      return;
    }
    setFeeStructure([
      ...feeStructure,
      {
        fee_type: "",
        amount: "",
        apply_on: "All Student",
      },
    ]);
  };

  const removeFeeRow = (index) => {
    setFeeStructure(feeStructure.filter((_, i) => i !== index));
  };

  const updateFeeRow = (index, field, value) => {
    const updated = [...feeStructure];
    updated[index][field] = value;
    setFeeStructure(updated);
  };
  const isFeeTypeSelected = (feeType, currentIndex) => {
    return feeStructure.some(
      (fee, index) =>
        index !== currentIndex && fee.fee_type === feeType
    );
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <AcademicPortalLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <form onSubmit={handleFormSubmit}>
                          <div className="row g-0">
                            <div className="col-12">
                              <h4 className="text-primary m-0">New Batch</h4>
                              <hr className="my-2" />
                            </div>

                            <div className="col-12">
                              <h6 className="mb-2">Basic Details</h6>
                              <div className="row g-2">
                                <div className="col-sm-2">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      name="session_id"
                                    >
                                      {sessions?.map((session) => (
                                        <option
                                          key={session?.id}
                                          value={session?.id}
                                          selected={session?.status === "1"}
                                        >
                                          {session?.session} :{" "}
                                          {session?.status === "1"
                                            ? "Active"
                                            : " Inactive"}
                                        </option>
                                      ))}
                                    </select>
                                    <label htmlFor="course">
                                      Select session
                                    </label>
                                  </div>
                                </div>

                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      id="course_id"
                                      name="course_id"
                                      required
                                    >
                                      <option value="" selected disabled>
                                        Select Course
                                      </option>
                                      {courses.map((course) => (
                                        <option
                                          key={course.id}
                                          value={course.id}
                                        >
                                          {course.title}
                                        </option>
                                      ))}
                                    </select>
                                    <label htmlFor="course">
                                      Select Course
                                    </label>
                                  </div>
                                </div>

                                <div className="col-sm-4">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="text"
                                      className="form-control input-uppercase"
                                      id="title"
                                      placeholder="Enter Batch Name"
                                      name="title"
                                      required
                                      onChange={(e) => {
                                        e.target.value =
                                          e.target.value.toUpperCase();
                                      }}
                                    />
                                    <label htmlFor="title">Batch Title</label>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      name="class_teacher"
                                    >
                                      <option value="" selected disabled>
                                        Select Staff
                                      </option>
                                      {staffs?.map((staff) => (
                                        <option
                                          key={staff?.id}
                                          value={staff?.id}
                                        >
                                          {staff?.name}
                                        </option>
                                      ))}
                                    </select>

                                    <label htmlFor="teacher">
                                      Batch/Class Teacher
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <hr className="my-2" />
                            </div>

                            <div className="col-12">
                              <div className="d-flex align-items-center justify-content-between">
                                <h6 className="mb-2">Batch Fee Structure</h6>
                                <button
                                  type="button"
                                  className="btn btn-success px-2 py-1"
                                  onClick={addFeeRow}
                                >
                                  +
                                </button>
                              </div>
                              {feeStructure.map((fee, index) => (
                                <div
                                  className="row g-2 mb-2 align-items-center"
                                  key={index}
                                >
                                  <div className="col-md-4">
                                    <div className="form-floating form-floating-outline">
                                      <select
                                        className="form-select"
                                        value={fee.fee_type}
                                        name={`fee_type[${index}]`}
                                        required
                                        onChange={(e) =>
                                          updateFeeRow(
                                            index,
                                            "fee_type",
                                            e.target.value,
                                          )
                                        }
                                      >
                                        <option value="" selected disabled>
                                          Select Fee Type
                                        </option>
                                        {feeTypes.map((type) => (
                                          <option
                                            key={type}
                                            value={type}
                                            disabled={isFeeTypeSelected(type, index)}
                                          >
                                            {type}
                                          </option>
                                        ))}
                                      </select>
                                      <label htmlFor="">Select Fee Type</label>
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="form-floating form-floating-outline">
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Amount"
                                        name={`amount[${index}]`}
                                        value={fee.amount}
                                        required
                                        min="0"
                                        onChange={(e) =>
                                          updateFeeRow(
                                            index,
                                            "amount",
                                            e.target.value,
                                          )
                                        }
                                      />
                                      <label htmlFor="">Amount</label>
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="d-flex gap-2 align-items-center">
                                      <div className="form-floating form-floating-outline w-100">
                                        <select
                                          className="form-select"
                                          value={fee.apply_on}
                                          name={`apply_on[${index}]`}
                                          required
                                          onChange={(e) =>
                                            updateFeeRow(
                                              index,
                                              "apply_on",
                                              e.target.value,
                                            )
                                          }
                                        >
                                          <option value="All Student">
                                            All Students
                                          </option>

                                          <option value="New Student">
                                            Only New Students
                                          </option>
                                          <option value="Selected Student">
                                            Selected Students
                                          </option>
                                        </select>
                                        <label htmlFor=""> Apply For</label>
                                      </div>
                                      <button
                                        type="button"
                                        className="btn btn-danger  px-2 py-1"
                                        onClick={() => removeFeeRow(index)}
                                      >
                                        <i className="ri-delete-bin-line"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                              <hr className="my-2" />
                            </div>
                            <div className="col-12">
                              <h6 className="mb-2">Batch Timing</h6>
                              <div className="row g-2">
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="duration"
                                      placeholder="Duration in Months"
                                      name="duration"
                                      required
                                      min={0}
                                    />
                                    <label htmlFor="duration">
                                      Duration (Months)
                                    </label>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="date"
                                      className="form-control"
                                      id="starting_date"
                                      name="starting_date"
                                      required
                                    />
                                    <label htmlFor="starting_date">
                                      Starting Date
                                    </label>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="time"
                                      className="form-control"
                                      id="start_time"
                                      name="start_time"
                                      required
                                    />
                                    <label htmlFor="start_time">
                                      Start Timing
                                    </label>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="time"
                                      className="form-control"
                                      id="end_time"
                                      name="end_time"
                                      required
                                    />
                                    <label htmlFor="end_time">End Time</label>
                                  </div>
                                </div>
                              </div>
                              <hr className="my-2" />
                            </div>
                            <div className="col-12">
                              <h6 className="mb-2">Other Details</h6>
                              <div className="row g-2">
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="student_limit"
                                      placeholder="student_limit"
                                      name="student_limit"
                                      min="0"
                                    />
                                    <label htmlFor="student_limit">
                                      Student Limit
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div className="col-sm-12">
                              <button
                                type="submit"
                                className="btn btn-primary px-5"
                                disabled={loading}
                              >
                                {loading ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  "Submit"
                                )}
                                {loading ? " Submitting..." : ""}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
